import { sendItemApiDataMail } from './send-item-api-data-mail'
import sendMessageToSidebarWithIds from './send-message-to-sidebar-with-ids'

export async function sendMessageToSidebarWithIdsAfterComposeChanges(
  messageType: string,
  messageArgs: any,
  subject: string,
  people: any,
): Promise<any> {
  const sentMessageArgs = await sendMessageToSidebarWithIds(messageType, messageArgs, subject, people)

  if (sentMessageArgs.id) {
    await sendItemApiDataMail()
  }
}
